/**
 * One vocabulary of failures for every wallet.
 *
 * Adapters throw their own classes from a chunk that is not loaded until the modal opens,
 * so classification reads `name` and `message` rather than importing the classes — the
 * facade stays free of vendor imports and the marketing bundle stays free of the adapters.
 * Every code here has a string in the i18n catalogue; nothing reaches the screen raw.
 */
export class WalletFailure extends Error {
    code;
    walletId;
    constructor(code, walletId = null, message) {
        super(message ?? code);
        this.name = "WalletFailure";
        this.code = code;
        this.walletId = walletId;
    }
}
/** Substrings the wallets actually produce when the person says no. */
const REJECTION = [
    "reject",
    "declined",
    "denied",
    "cancel",
    "user closed",
    "0x6985", // Ledger: the person pressed the reject button on the device
];
const LOCKED = ["locked", "no wallet account", "unlock"];
/** Ledger status words for "the Tron app is not the one on screen". */
const LEDGER_APP_CLOSED = ["0x6d00", "0x6511", "0x6e00", "unknown_apdu", "incorrect length"];
const LEDGER_UNSUPPORTED = ["webhid", "not supported", "notsupportederror", "no device selected"];
export function classifyWalletError(error, walletId = null) {
    if (error instanceof WalletFailure)
        return error;
    const name = String(error?.name ?? "");
    const raw = String(error?.message ?? error ?? "");
    const text = raw.toLowerCase();
    const has = (needles) => needles.some((needle) => text.includes(needle));
    if (name === "WalletNotFoundError")
        return new WalletFailure("not_installed", walletId, raw);
    if (name === "WalletWindowClosedError")
        return new WalletFailure("connection_closed", walletId, raw);
    if (walletId === "Ledger") {
        if (has(LEDGER_APP_CLOSED))
            return new WalletFailure("ledger_app_closed", walletId, raw);
        if (has(LEDGER_UNSUPPORTED))
            return new WalletFailure("ledger_unsupported", walletId, raw);
    }
    if (has(REJECTION))
        return new WalletFailure("rejected", walletId, raw);
    if (has(LOCKED))
        return new WalletFailure("locked", walletId, raw);
    if (name === "WalletDisconnectedError")
        return new WalletFailure("locked", walletId, raw);
    if (name === "WalletSignMessageError" || name === "WalletSignTransactionError") {
        return new WalletFailure("sign_failed", walletId, raw);
    }
    if (name === "WalletConnectionError")
        return new WalletFailure("unavailable", walletId, raw);
    return new WalletFailure("unavailable", walletId, raw);
}
//# sourceMappingURL=errors.js.map